// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UpdatedTCModal from '../components/UpdatedTCModal';
import { updateLoggedInUser } from '../actions';
import { getPublicSetting } from '../actions/settings/settingsCreators';
import type { User, Dispatch } from '../types';

type State = {
  showTCModal: boolean,
  isSaving: boolean,
  errorMsg: ?string,
  successMsg: ?string
};

type Props = {
  needToSignTC: boolean,
  loggedInUser: Object,
  settings: ?Object,
  updateLoggedInUser: (u: User | Object) => Promise<void>,
  getPublicSetting: (s: string) => void
};

class UpdatedTCModalContainer extends React.Component<Props, State> {
  timeoutId: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      needToSignTC: props.needToSignTC,
      showTCModal: props.needToSignTC,
      isSaving: false,
      errorMsg: undefined,
      successMsg: undefined
    };
    this.timeoutId = undefined;
  }
  componentDidMount() {
    const { getPublicSetting } = this.props;
    getPublicSetting('tcPdf');
  }

  handleSubmit = (values: { acceptTerms: boolean }) => {
    this.setState({ isSaving: true, errorMsg: undefined });
    if (!values.acceptTerms) {
      return this.setState({
        errorMsg:
          'You need to accept the terms and conditions before continuing.',
        isSaving: false
      });
    }
    const user = {
      dateUpdated: this.props.loggedInUser.dateUpdated,
      dateTcSigned: new Date().toISOString()
    };
    return this.props
      .updateLoggedInUser(user)
      .then(response => this.success(response), error => this.failure(error));
  };

  success = response => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg: 'Success!'
    });
    this.timeoutId = setTimeout(
      () => this.setState({ successMsg: undefined, showTCModal: false }),
      3000
    );
  };

  failure = (error: Object) => {
    this.setState({
      isSaving: false,
      errorMsg: error.data.message
    });
  };

  render() {
    const { showTCModal, isSaving } = this.state;
    const { settings } = this.props;

    return (
      <UpdatedTCModal
        showTCModal={showTCModal}
        title="Updated Terms and Conditions"
        description="Please read our updated terms and conditions before continuing."
        isSaving={isSaving}
        onSubmit={this.handleSubmit}
        errorMsg={this.state.errorMsg}
        successMsg={this.state.successMsg}
        termsLinkUrl={
          settings && settings.tcPdf ? settings.tcPdf.value : undefined
        }
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    settings: state.settings
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      updateLoggedInUser,
      getPublicSetting
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdatedTCModalContainer);



// WEBPACK FOOTER //
// ./src/containers/UpdatedTCModalContainer.js